/**
 * Event-driven system for handling game mechanics and custom keywords
 * Enables extensible effect system without hardcoding keyword logic
 */
export class EventBus {
    listeners = new Map();
    history = [];
    maxHistorySize = 1000;
    /**
     * Register an event handler for a specific event type
     */
    on(eventType, handler) {
        if (!this.listeners.has(eventType)) {
            this.listeners.set(eventType, new Set());
        }
        this.listeners.get(eventType).add(handler);
    }
    /**
     * Unregister an event handler
     */
    off(eventType, handler) {
        const handlers = this.listeners.get(eventType);
        if (handlers) {
            handlers.delete(handler);
        }
    }
    /**
     * Emit an event to all registered handlers
     */
    emit(event) {
        const fullEvent = {
            ...event,
            timestamp: Date.now(),
        };
        // Store in history
        this.history.push(fullEvent);
        if (this.history.length > this.maxHistorySize) {
            this.history.shift();
        }
        // Execute handlers
        const handlers = this.listeners.get(event.type);
        if (handlers) {
            for (const handler of handlers) {
                try {
                    handler(fullEvent);
                }
                catch (error) {
                    console.error(`Error in event handler for ${event.type}:`, error);
                }
            }
        }
    }
    /**
     * Get all events since a certain time or last N events
     */
    getHistory(limit) {
        if (limit) {
            return this.history.slice(-limit);
        }
        return [...this.history];
    }
    /**
     * Clear event history
     */
    clearHistory() {
        this.history = [];
    }
    /**
     * Clear all listeners (useful for testing)
     */
    clearListeners() {
        this.listeners.clear();
    }
}
